import { SESSION_COOKIE_NAME } from "@pdfking/constants/settings"
import user_get from "@pdfking/workflow/utils/user_get"
import cookie_get from "../utils/cookie_get"

export default () => {
  return user_get(cookie_get(SESSION_COOKIE_NAME))
}
